import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../graphql/auth';
import {gqlLoggedInUser, setMe} from '../../graphql/auth/getMe';
import {writeLocalAuthToken} from '../../graphql/GraphQlProvider';

interface LoginUserVars {
  username: string;
  password: string;
}

interface LoginUserData {
  login: {
    access_token: string,
    user: User,
  }
}

export const LOGIN_MUTATION = gql`
    mutation loginUser($username: String!, $password: String!) {
        login(input: {username: $username, password: $password}) {
            access_token
            user {
                ${gqlLoggedInUser}
            }
        }
    }
`;

export const loginUser = () => useMutation<LoginUserData, LoginUserVars>(
  LOGIN_MUTATION,
  {
    update: (proxy, response) => {
      const me = response.data!.login.user;
      setMe(proxy, me);
    },
    onCompleted: (response: LoginUserData) => {
      if(response && response.login) {
        onLoginComplete(response.login.access_token)
      }
    }
  }
);

export const onLoginComplete = (accessToken: string) => {
  writeLocalAuthToken(accessToken);
};

export default loginUser;
